import React , { useState } from 'react';
import { Button } from '../../globalStyles';
import ReactDOM from "react-dom";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin,
  FaWhatsapp,
  FaPhoneAlt,
  
} from 'react-icons/fa';

import {
  MdWork,
  
} from 'react-icons/md';
import {
  IoIosPin,
  
} from 'react-icons/io';

import {
  CardWrapper,
  SocialLink,
  CardHeader,
  AddressContainer,
  CardHeading,
  CardBody,
  CardIcon,
  CardFieldset,
  CardInput,
  CardOptionsItem,
  CardOptions,
  CardOptionsNote,
  AddressWrapper,
  EmailContainer,
EmailIcon,
AddressIcon,
  CardButton,
  CardLink,
  MapWrapper,
  ContactSection,
  SocialContainer,
  MapContainer,
  ContactWrapper,
  ContactText,
  ContactgHeading,
ContactContainer,
googlemapcode,
IFrame,
EmaiWrapper,
SocialIconLink,
SocialWrapper
} from './Contact.elements';
import ContactForm from './ContactForm';

function Contact() {
  return (
    <ContactSection>
     <ContactgHeading> Contact As </ContactgHeading>


        <ContactContainer>
        <ContactWrapper>
            <SocialIconLink href='/' target='_blank' aria-label='FaPhoneAlt'>
              <FaPhoneAlt />
            </SocialIconLink>
                  <ContactText>Landline : 23961856</ContactText>
      </ContactWrapper>
      <ContactWrapper>
            <SocialIconLink href='/' target='_blank' aria-label='FaWhatsapp'>
              <FaWhatsapp style={{marginLeft:'-50px',}}/>
            </SocialIconLink>
                  <ContactText>Phone number : 01008060170</ContactText>
      </ContactWrapper>       
      </ContactContainer>

      <SocialContainer>
            <SocialLink href='/' target='_blank' aria-label='FaFacebook'>
              <FaFacebook />
            </SocialLink>
            <SocialLink href='/' target='_blank' aria-label='FaLinkedin'>
              <FaLinkedin />
            </SocialLink>
            <SocialLink href='/' target='_blank' aria-label='FaYoutube'>
              <FaYoutube />
            </SocialLink>
            <SocialLink href='/' target='_blank' aria-label='FaTwitter'>
              <FaTwitter />
            </SocialLink>
            <SocialLink href='/' target='_blank' aria-label='FaInstagram'>
              <FaInstagram />
            </SocialLink>
      </SocialContainer>
 <EmailContainer>
        <EmaiWrapper>
                          <ContactText>For more inquires about our services.</ContactText>

            <EmailIcon href='/' target='_blank' aria-label='FaPhoneAlt'>
              <FaPhoneAlt />
            </EmailIcon>
                  <ContactText>info@novoelevators.com</ContactText>
      </EmaiWrapper>
      <EmaiWrapper>
                        <ContactText>For requesting price offer.</ContactText>

            <EmailIcon href='/' target='_blank' aria-label='FaWhatsapp'>
              <FaWhatsapp />
            </EmailIcon>
                  <ContactText>Sales@novoelevators.com</ContactText>
      </EmaiWrapper>    
      <EmaiWrapper>
                        <ContactText>If you want to be with us, please upload your resume.</ContactText>

            <EmailIcon href='/' target='_blank' aria-label='MdWork'>
              <MdWork />
            </EmailIcon>
                  <ContactText>Recruitment@novoelevators.com</ContactText>
      </EmaiWrapper>      
      </EmailContainer>
      

<AddressContainer>
<AddressWrapper>
            <SocialIconLink href='/' target='_blank' aria-label='IoIosPin' >
              <IoIosPin style={{marginLeft:'-50px',}}/>
            </SocialIconLink>
                  <ContactText>Address: Downtown,Cairo,Egypt</ContactText>
      </AddressWrapper>
      <AddressWrapper>
          <iframe className="IFrame" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6907.2197405045445!2d31.231997324663258!3d30.04804841448826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145840c7487e04cd%3A0x3377b407fe2c3754!2sDowntown%20Cairo%2C%20Bab%20Al%20Louq%2C%20Abdeen%2C%20Cairo%20Governorate!5e0!3m2!1sen!2seg!4v1608644728661!5m2!1sen!2seg" width="100%" height="100%" frameborder="0" style={{border:0, }}allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </AddressWrapper>

      </AddressContainer>
      <ContactForm />
    </ContactSection>
     

            
  );
}

export default Contact;
